import React, { useEffect, useState } from "react";
import Select from "react-select";
import {
  Card,
  CardBody,
  CardFooter,
  Button,
  Dialog,
  Input,
  DialogBody,
  DialogFooter,
  DialogHeader,
  Typography,
} from "@material-tailwind/react";
import axios from "axios";
import {
  validateZipCode,
  validateState,
  validUSAStates,
} from "../../helpers/validationHelpers";
import { useWallet, useAddress } from '@thirdweb-dev/react';
import { useNavigate } from 'react-router-dom';

// import DatePicker from "react-datepicker";
// import "react-datepicker/dist/react-datepicker.css";


export function PatientSignup() {

  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://127.0.0.1:3001";
  
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    dob: new Date(),
    address1: "",
    address2: "",
    state: "",
    zipcode: "",
    healthInsuranceNumber: "",
    consent: false,
    walletAddress: "", // Assuming walletAddress is part of your form data
  });

  const navigate = useNavigate();
  const [zipcodeValidationColor, setZipcodeValidationColor] = useState("");
  const [open, setOpen] = React.useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const handleOpen = () => setOpen(!open);
  const walletInstance = useWallet();
  const walletAddress = useAddress();

  const [isWalletConnected, setIsWalletConnected] = useState(false);
  const [walletAddressState, setWalletAddressState] = useState('');
  const [isConnectWalletModalOpen, setIsConnectWalletModalOpen] = useState(false);

useEffect(() => {
  setIsWalletConnected(!!walletInstance);
  if (walletInstance && walletAddress) {
    setIsWalletConnected(true);
    setWalletAddressState(walletAddress);
    setFormData(prevState => ({
      ...prevState,
      walletAddress,  // <-- update walletAddress in formData
  }));
  }
}, [walletInstance, walletAddress]);

//Handlers
  const handleConsentChange = () => {
    setFormData((prevState) => ({
      ...prevState,
      consent: !prevState.consent,
    }));
  };

  const handleStateChange = (selectedOption) => {
    setFormData((prevState) => ({
      ...prevState,
      state: selectedOption ? selectedOption.value : "",
    }));
  };

  const validateForm = () => {
    let errors = [];

    // if (!VALID_STATES.includes(formData.state)) {
    //   errors.push('Invalid State');
    // }

    if (!/^[a-zA-Z]+$/.test(formData.firstName)) {
      errors.push("First Name can only contain alphabetic characters");
    }
    if (!/^[a-zA-Z]+$/.test(formData.lastName)) {
      errors.push("Last Name can only contain alphabetic characters");
    }

    // if (formData.walletAddress) {
    //   errors.push("Wallet Address cannot be empty");
    //   handleOpen(); // Open the modal
    // }

    return errors;
  };

  const handleChange = async (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    if (name === "zipcode") {
      const isValidZip = await validateZipCode(value);
      setZipcodeValidationColor(isValidZip ? "green" : "red");
    }
    if (name === "state") {
      // If you want to handle invalid state input
      const isValidState = validateState(value);
      if (!isValidState) {
        console.error("Invalid state");
      }
    }
  };

  // ... rest of your existing functions ...

  const handleSubmit = async (e) => {
    e.preventDefault();

    const errors = validateForm();
    if (errors.length > 0) {
      console.error("Form validation errors:", errors);
      return;
    }

    if(!isWalletConnected){
      setIsConnectWalletModalOpen(true);
    }

    else{
    try {
      console.log(formData.walletAddress);
      const response = await axios.post(
        `${API_BASE_URL}/create-patient`,
        formData
      );
      // Set modal open state to true
      setIsModalOpen(true);
      // Clear form data
      setFormData({
        firstName: "",
        lastName: "",
        dob: new Date(),
        address1: "",
        address2: "",
        state: "",
        zipcode: "",
        healthInsuranceNumber: "",
        consent: false,
      });
      console.log("Form data submitted successfully:", response.data);
    } catch (error) {
      console.log(formData.walletAddress);
      console.error(
        "There was a problem with the request:",
        error.response ? error.response.data : error.message
      );
    }
  }
  };

  const closeModal = () => {
    setIsConnectWalletModalOpen(false);
  };

  return (
    <div className="radial-gradient-background">
      <div className="flex justify-center items-center h-full">
        <Card className="ml-5 mt-6 w-full md:max-w-screen-md lg:w-96">
          <CardBody>
            <Typography variant="h2" color="blue">
              Patient Profile
            </Typography>
            <form onSubmit={handleSubmit}>
              {/* First Name */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="First Name*"
                  name="firstName"
                  value={formData.firstName}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              {/* Last Name */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="Last Name*"
                  name="lastName"
                  value={formData.lastName}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              {/* Date of Birth */}
              {/* <div className="w-90 mb-5">
              <label className="block text-blue-500 text-sm font-bold mb-2">
                Date of Birth*
              </label>
              <DatePicker
                selected={formData.dob}
                onChange={handleDateChange}
                dateFormat="MM/dd/yyyy"
                className="w-full p-3 border border-gray-300 rounded"
              />
            </div> */}
              {/* Address 1 */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="Address 1*"
                  name="address1"
                  value={formData.address1}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              {/* Address 2 */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="Address 2"
                  name="address2"
                  value={formData.address2}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              {/* State */}
              <div className="w-90 mb-5">
                <label className="block text-blue-500 text-sm font-bold mb-2">
                  State*
                </label>
                <Select
                  name="state"
                  options={validUSAStates.map((state) => ({
                    value: state,
                    label: state,
                  }))}
                  value={{ value: formData.state, label: formData.state }}
                  onChange={(selectedOption) =>
                    handleChange({
                      target: { name: "state", value: selectedOption.value },
                    })
                  }
                />
              </div>
              {/* Zipcode */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="Zipcode*"
                  name="zipcode"
                  value={formData.zipcode}
                  onChange={handleChange}
                  autoComplete="off"
                  style={{ borderColor: zipcodeValidationColor }}
                />
              </div>
              {/* Health Insurance Number */}
              <div className="w-90 mb-5">
                <Input
                  color="blue"
                  label="Health Insurance Number*"
                  name="healthInsuranceNumber"
                  value={formData.healthInsuranceNumber}
                  onChange={handleChange}
                  autoComplete="off"
                />
              </div>
              {/* Consent */}
              <div className="w-90 mb-5">
                <label className="flex items-center">
                  <input
                    type="checkbox"
                    name="consent"
                    checked={formData.consent}
                    onChange={handleConsentChange}
                  />
                  <span className="ml-2">Consent to processing data</span>
                </label>
              </div>
            </form>
          </CardBody>
          <CardFooter className="pt-0">
            <Button color="teal" onClick={handleSubmit} type="button">
              Submit
            </Button>
          </CardFooter>

          <Dialog open={open} handler={handleOpen} /* ...other props... */>
            {/* ...dialog content... */}
          </Dialog>
        </Card>
      </div>

      {/* Success Modal */}
      <Dialog open={isModalOpen} handler={() => setIsModalOpen(false)}>
        <DialogHeader>Submission Successful</DialogHeader>
        <DialogBody>Your data has been submitted successfully!</DialogBody>
        <DialogFooter>
          <Button color="green" onClick={() => setIsModalOpen(false)}>
            Ok
          </Button>
        </DialogFooter>
      </Dialog>

      {/* Connect Wallet Modal */}
      <Dialog
        open={isConnectWalletModalOpen}
        onClose={closeModal}
        animate={{
          mount: { top: "0%", right: "0%", transition: "slideInRight" },
          unmount: { top: "0%", right: "-100%", transition: "slideOutRight" }
        }}
      >
        <div className="p-4 text-center">
          <span className="text-6xl" role="img" aria-label="Wallet Emoji">👛</span>
          <p className="mt-4 text-xl font-bold">Please connect your wallet to proceed.</p>
          <Button 
            color="gray" 
            variant="outline" 
            onClick={closeModal} 
            className="mt-4 text-white"
          >
            Cool, Thanks!
          </Button>
        </div>
      </Dialog>
    </div>
  );
}
